import React, {useState} from "react";
import {Row} from "antd";
import {useObserver} from "mobx-react-lite";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import Filters from "components/equipments/equipmentRequests/filters/Filters";
import ResponsiveDataTable from "components/equipments/equipmentRequests/responsiveDataTable/ResponsiveDataTable";

const MyEquipmentRequestsTab = ({recall}) => {
    const stores = useStore();
    const [localRecall, setLocalRecall] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        status: "all",
        zoneManagementId: undefined,
        zoneId: undefined,
        startDate: undefined,
        endDate: undefined,
        searchText: undefined
    });

    const [loading, requests] = useFetch({
        fetchFn: stores.equipmentRequestStore.listRequests.bind(null, {
            limit: 10,
            page: currentPage,
            status: filters?.status !== "all" ? filters?.status : undefined,
            zoneManagementId: filters?.zoneManagementId,
            zoneId: filters?.zoneId,
            startDate: filters?.startDate,
            endDate: filters?.endDate,
            searchText: filters?.searchText
        }),
        dependencies: [localRecall, recall, filters, currentPage]
    });

    return useObserver(() => (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row style={{marginTop: 16}}>
                <ResponsiveDataTable
                    loading={loading}
                    data={requests?.rows || []}
                    dataCount={requests?.total || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    recall={() => setLocalRecall(prev => !prev)}
                />
            </Row>
        </div>
    ));
};

export default MyEquipmentRequestsTab;
